"use strict";

exports.__esModule = true;
exports.default = void 0;
var _createEscaper = _interopRequireDefault(require("./_createEscaper.js"));
var _escapeMap = _interopRequireDefault(require("./_escapeMap.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Function for escaping strings to HTML interpolation.
var _default = exports.default = (0, _createEscaper.default)(_escapeMap.default);